import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const TaxonomyIcon = (props) => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.8333 2.49992H12.3467C12.0025 1.53075 11.0867 0.833252 10 0.833252C8.91333 0.833252 7.9975 1.53075 7.65333 2.49992H4.16667C3.24583 2.49992 2.5 3.24575 2.5 4.16659V15.8333C2.5 16.7541 3.24583 17.4999 4.16667 17.4999H11.6682C11.6925 17.0143 11.9991 16.5976 12.4667 16.2499C12.9007 15.9256 13.4742 15.6611 14.0798 15.4602C13.4892 14.8588 13.125 14.0344 13.125 13.1249C13.125 11.284 14.6174 9.79158 16.4583 9.79158C16.8221 9.79158 17.1723 9.84986 17.5 9.95758V4.16659C17.5 3.24575 16.7542 2.49992 15.8333 2.49992ZM10 2.49992C10.46 2.49992 10.8333 2.87325 10.8333 3.33325C10.8333 3.79325 10.46 4.16659 10 4.16659C9.54 4.16659 9.16667 3.79325 9.16667 3.33325C9.16667 2.87325 9.54 2.49992 10 2.49992ZM11.5667 11.1962L12.9601 9.9895C13.1419 9.83229 13.0448 9.53446 12.8066 9.51296L10.968 9.35575L10.2507 7.66331C10.1568 7.44223 9.84418 7.44285 9.75084 7.66331L9.03296 9.36067L7.19497 9.51788C6.95547 9.53875 6.85906 9.83659 7.04022 9.9938L8.43422 11.1993L8.0154 12.9973C7.97978 13.1503 8.07927 13.2725 8.207 13.3105L8.20209 13.332L8.22604 13.3179C8.28867 13.332 8.355 13.3308 8.41948 13.2921L10.0002 12.339L11.5808 13.2933C11.6453 13.332 11.7116 13.3333 11.7749 13.3191L11.7982 13.3333L11.7933 13.3124C11.9217 13.2743 12.0205 13.1521 11.9855 12.9998L11.5667 11.1962Z"
      fill={props.sx?.color || '#080F1D'}
    />
    <path
      d="M17.5 16.7501C17.2 16.6917 16.9167 16.6667 16.6834 16.6667C16.675 16.6667 16.675 16.6667 16.6667 16.6667C15.9 16.6667 14.5917 16.9584 13.8667 17.5001C13.5417 17.7417 13.3334 18.0334 13.3334 18.3751V20.0001H20V18.3751C20 17.5084 18.625 16.9501 17.5 16.7501Z"
      fill={props.sx?.color || '#080F1D'}
    />
    <circle
      cx="16.6667"
      cy="13.3334"
      r="1.66667"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

TaxonomyIcon.propTypes = {
  sx: PropTypes.object,
};

export default TaxonomyIcon;
